<template>
    <DCard
        :title="__('messages.dashboard.widgets.mrr.title') + ' - ' + __('messages.dashboard.widgets.mrr.description')"
        class="height widget p-3 card"
    >
        <DTable
            :items="mrrData"
            :fields="fields"
            hover
            class="w-100 mrr-table"
        />
    </DCard>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { __ } from '~@/Composables/translation'

import { route } from '~@/Composables/route'

const fields = ref(
    [
        { key: 'brand_name', label: __('messages.dashboard.widgets.mrr.table.brand') },
        { key: 'active_mrr', label: __('messages.dashboard.widgets.mrr.table.active') },
        { key: 'churned_mrr', label: __('messages.dashboard.widgets.mrr.table.churned') },
        { key: 'total_mrr', label: __('messages.dashboard.widgets.mrr.table.total') }
    ]
)

const mrrData = ref()

onMounted(() => {
    window.axios.get(route('widgets.get-data'), {
        params: {
            widget: 'mrr'
        }
    })
        .then(function (response) {
            mrrData.value = response.data.data
        })
})
</script>

<style>
.mrr-table th:not(:first-child), .mrr-table tr td:not(:first-child) {
    text-align: right;
}
</style>
